import { Redirect, Route } from "react-router-dom";
import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* import '@ionic/react/css/palettes/dark.always.css'; */
/* import '@ionic/react/css/palettes/dark.class.css'; */
import "@ionic/react/css/palettes/dark.system.css";

/* Theme variables */
import "./theme/variables.css";
import IdentificationVehicle from "./pages/IdentificationVehicle";
import IdentificationTrailer from "./pages/IdentificationTrailer";
import InspectionFinish from "./pages/Inspection/InspectionFinish";
import Inspection from "./pages/Inspection/Inspection";
import Login from "./pages/Login";
import { AuthProvider, RequireAuth } from "./api/auth";
import { QueryClient, QueryClientProvider } from "react-query";
import FinishJourney from "./pages/FinishJourney/finishJourney";
import { ToastProvider } from "./components/ToastContext";

setupIonicReact();
export const queryClient = new QueryClient();

const App: React.FC = () => (
  <IonApp>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <IonReactRouter>
            <IonRouterOutlet>
              <RequireAuth>
                <>
                  <Route exact path="/">
                    <IdentificationVehicle />
                  </Route>
                  <Route exact path="/inspection/:id/:type/:side">
                    <Inspection />
                  </Route>
                  <Route exact path="/identification/:vehicleId/trailer">
                    <IdentificationTrailer />
                  </Route>
                  <Route exact path="/inspection/:journeyId/finish">
                    <InspectionFinish />
                  </Route>
                  <Route exact path="/inspection/:vehicleId/finishjourney">
                    <FinishJourney />
                  </Route>
                </>
              </RequireAuth>
              <Route exact path="/login">
                <Login />
              </Route>
            </IonRouterOutlet>
          </IonReactRouter>
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </IonApp>
);

export default App;
